//#region src/location_group_designation.ts
var LocationGroupDesignation = /* @__PURE__ */ function(LocationGroupDesignation) {
	LocationGroupDesignation["OrgWide"] = "org-wide";
	LocationGroupDesignation["AllLive"] = "all-live";
	LocationGroupDesignation["SingleLocation"] = "single-location";
	LocationGroupDesignation["ManuallyCreated"] = "manually-created";
	return LocationGroupDesignation;
}(LocationGroupDesignation || {});
//#endregion
export { LocationGroupDesignation };

//# sourceMappingURL=location_group_designation.js.map